// Module Vuex pour la gestion des listes
const state = {
  items: [],
  rows: [],
  loading: false,
  totalLoading: false,
  progressiveLoading: false,
  error: null,
  filters: {},
  pagination: {
    page: 1,
    limit: 20,
    total: 0
  },
  ready: false
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_ROWS(state, rows) {
    state.rows = rows
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_TOTAL_LOADING(state, loading) {
    state.totalLoading = loading
  },
  SET_PROGRESSIVE_LOADING(state, loading) {
    state.progressiveLoading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_FILTERS(state, filters) {
    state.filters = filters
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...state.pagination, ...pagination }
  },
  SET_READY(state, ready) {
    state.ready = ready
  },
  UPDATE_ROW(state, { index, row }) {
    if (state.rows[index]) {
      state.rows[index] = { ...state.rows[index], ...row }
    }
  },
  UPDATE_ROW_LOADING(state, { rowId, loading }) {
    const rowIndex = state.rows.findIndex(row => row.id === rowId)
    if (rowIndex !== -1) {
      state.rows[rowIndex] = { ...state.rows[rowIndex], loading }
    }
  }
}

const actions = {
  setItems({ commit }, items) {
    commit('SET_ITEMS', items)
  },
  setRows({ commit }, rows) {
    commit('SET_ROWS', rows)
  },
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading)
  },
  setTotalLoading({ commit }, loading) {
    commit('SET_TOTAL_LOADING', loading)
  },
  setProgressiveLoading({ commit }, loading) {
    commit('SET_PROGRESSIVE_LOADING', loading)
  },
  setError({ commit }, error) {
    commit('SET_ERROR', error)
  },
  setFilters({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },
  setPagination({ commit }, pagination) {
    commit('SET_PAGINATION', pagination)
  },
  setReady({ commit }, ready) {
    commit('SET_READY', ready)
  },
  updateRow({ commit }, payload) {
    commit('UPDATE_ROW', payload)
  },
  updateRowLoading({ commit }, payload) {
    commit('UPDATE_ROW_LOADING', payload)
  },
  
  // Actions pour le progressive loading
  async loadItemsProgressively({ commit }, { items, batchSize = 5, delay = 100 }) {
    commit('SET_PROGRESSIVE_LOADING', true)
    
    // Créer des placeholders de chargement
    const placeholders = items.map((_, index) => ({
      id: `loading-${index}`,
      loading: true,
      data: [
        [{ type: 'TextLoading', value: 'medium' }],
        [{ type: 'TextLoading', value: 'long' }],
        [{ type: 'TextLoading', value: 'short' }],
        [{ type: 'TextLoading', value: 'medium' }]
      ]
    }))
    
    commit('SET_ROWS', placeholders)
    
    // Charger les éléments par batch
    for (let i = 0; i < items.length; i += batchSize) {
      const batch = items.slice(i, i + batchSize)
      
      // Transformer le batch en lignes
      batch.forEach((item, batchIndex) => {
        const globalIndex = i + batchIndex
        const transformedRow = {
          id: item.id,
          loading: false,
          checked: false,
          data: item.data, // Supposer que les données sont déjà transformées
          dropdown: {
            open: false,
            actions: []
          }
        }
        
        commit('UPDATE_ROW', { index: globalIndex, row: transformedRow })
      })
      
      // Attendre un délai pour l'effet visuel
      if (i + batchSize < items.length) {
        await new Promise(resolve => setTimeout(resolve, delay))
      }
    }
    
    commit('SET_PROGRESSIVE_LOADING', false)
    commit('SET_READY', true)
  }
}

const getters = {
  items: state => state.items,
  rows: state => state.rows,
  loading: state => state.loading,
  totalLoading: state => state.totalLoading,
  progressiveLoading: state => state.progressiveLoading,
  error: state => state.error,
  filters: state => state.filters,
  pagination: state => state.pagination,
  ready: state => state.ready
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
